import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import storageService from "../services/storage.service";
import HelperService from "../services/helper.service";

const ModalProgPickup = (props) => {
  const { isLoading, Title, Message, close, cancel, show,
    selectedDataDashboard, handleJustificationChange,
    handleCheckboxChange, disableYesButton, justification,
    configValue, checkboxState, totalCount, checkedCount,
    selectedEquipmentsForAssociation,
    pickupJustificationList,
    uncheckedCount, childre } = props;
  const { t } = useTranslation();
  // Estado local para os checkboxes
  const [localCheckboxState, setLocalCheckboxState] = useState(checkboxState);
  // Estado para o valor do textarea
  const [justificationValue, setJustificationValue] = useState(justification);
  //const [selectedDataDashboard, setSelectedDataDashboard] = useState([]);
  // UseRef para guardar o valor temporário

  const justificationRef = useRef(justification);

  /*   useEffect(() => {
      if (props.selectedDataDashboard) {
        setSelectedDataDashboard(props.selectedDataDashboard);     
      }
    }, [props.selectedDataDashboard]); */
  useEffect(() => {
    if (!show) {
      resetTextarea();  // Limpar o valor do textarea quando o modal for fechado
    }
  }, [show]);

  // Determina se o campo de justificação deve ser desabilitado
  const disableJustificationInput = (totalCount - uncheckedCount) === 0;

  const timeoutRef = useRef(null);

  // Atualiza o valor temporário ao digitar
  const handleInputChange = (event) => {
    const newValue = event.target.value;

    // Apenas atualiza o valor temporário
    if (newValue.length <= 170) {
      //console.log("valors", newValue.length)
      setJustificationValue(newValue);
      justificationRef.current = newValue;

      // Limpa o timeout anterior
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Configura um novo timeout
      timeoutRef.current = setTimeout(() => {
        handleJustificationChange(justificationRef.current);
      }, 300); // 1000 ms = 1 segundos
    }
  };

  // Atualiza o estado principal ao perder foco
  const handleInputBlur = () => {
    // Limpa o timeout ao sair do campo
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    // Chama o handleJustificationChange para atualizar o estado principal
    handleJustificationChange(justificationRef.current);
  };

  // Função de callback otimizada para os checkboxes
  const onCheckboxChange = useCallback((idEquipment, dayName) => {
    // Atualiza o estado local imediatamente
    setLocalCheckboxState(prevState => {
      const checkboxId = `${idEquipment}-${dayName}`;
      const isChecked = !prevState[checkboxId];

      return {
        ...prevState,
        [checkboxId]: isChecked,
      };
    });

    // Operaçõea assíncronas, atualizando estado global ou processamento pesado
    setTimeout(() => {
      handleCheckboxChange(idEquipment, dayName);
    }, 0);
  }, [handleCheckboxChange]);


  // Função para limpar o textarea
  const resetTextarea = () => {
    setJustificationValue("");
  };

  return (
    <>
      <Modal as={Modal.Dialog} centered show={show} onHide={close} backdrop="static">
        <Modal.Header>
          <Modal.Title className='h6'>{Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={() => {
            close();
            resetTextarea(); // Limpa o textarea ao fechar
          }} />
        </Modal.Header>
        <Modal.Body>
          {props.Message}
          {/* {{(configValue && totalCount > 0) && (} */}
          {(configValue && 
            totalCount > 0 &&
            selectedDataDashboard?.some(item => item.pickupunderminsyssuggestednojustification !== true && item.flag_branchEquipBelowMinForApproval == true)
           ) && (
            <>
              <hr />
              <p dangerouslySetInnerHTML={{ __html: t("COLLECTION_SCHEDULE.EQUIPMENT_BELOW_COLLECTION", { interpolation: { escapeValue: false } }) }}></p>

              {/* Adicionando cabeçalhos das colunas */}
              <div style={{ display: "flex", fontWeight: "bold", marginBottom: "5px" }}>
                <span style={{ width: "80px" }}>{t("")}</span>
                <span style={{ width: "95px" }}>{t("")}</span>
                <span style={{ width: "90px", textAlign: "right" }}>{t("COLLECTION_SCHEDULE.MONETARIO")}</span>
                <span style={{ width: "60px", textAlign: "right" }}>{t("COLLECTION_SCHEDULE.FISICO")}</span>
              </div>
              {selectedDataDashboard
                .filter(data => data.pickupunderminsyssuggestednojustification !== true)
                .map((data) => (
                <CheckboxItem
                  key={`${data.code_equipment}-${data.dayOfWeek}`}
                  data={data}
                  onCheckboxChange={onCheckboxChange}
                  isChecked={checkboxState[`${data.id_equipment}-${data.day_name}`]}
                />
              ))}

              <br />
              <p dangerouslySetInnerHTML={{ __html: t("COLLECTION_SCHEDULE.WANT_TO_PROGRAM", { interpolation: { escapeValue: false } }) }}></p>

              <hr />
              <p>{t("COLLECTION_SCHEDULE.REASON_JUSTIFICATION")}</p>

              {Array.isArray(pickupJustificationList) && pickupJustificationList.length > 0 ? (
                <select
                  className="form-control"
                  value={justificationValue}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  disabled={disableJustificationInput}
                >
                  <option value="">Selecione uma justificativa</option>
                  {pickupJustificationList.map((item, index) => (
                    <option key={index} value={item.justification}>
                      {t(item.justification)}
                    </option>
                  ))}
                </select>
              ) : (
                <textarea
                  className="form-control"
                  value={justificationValue}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  disabled={disableJustificationInput}
                />
              )}

              <p dangerouslySetInnerHTML={{ __html: t("COLLECTION_SCHEDULE.FOOTER_PROGRAM", { interpolation: { escapeValue: false } }) }}></p>
            </>
          )}

            {selectedEquipmentsForAssociation?.some(item => item.associated.length > 0) && (
              <>
                <hr />
                <p>
                  {t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_ASSOCIATION_SCHEDULE_MODAL_MESSAGE")}
                </p>

                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '4px' }}>{t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_SELECTED")}</th>
                      <th style={{ textAlign: 'left', padding: '4px' }}>{t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_ASSOCIATED")}</th>
                    </tr>
                  </thead>
                  <tbody>
                      {selectedEquipmentsForAssociation.map((item) => (
                        <tr key={item.equipment}>
                          <td style={{ padding: '4px', verticalAlign: 'top' }}>
                            {item.equipment}
                          </td>
                          <td
                            style={{
                              padding: '4px',
                              whiteSpace: 'normal',        // permite quebra de linha
                              wordBreak: 'break-word',     // quebra palavras longas
                            }}
                          >
                            {item.associated.join(', ')}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                </table>
              </>
            )}
  
        </Modal.Body>

        <Modal.Footer>
          {props.children}
          <Button
            disabled={props.isLoading || props.disableYesButton}
            variant='link'
            className='text-gray ms-auto'
            onClick={() => {
              close();
              resetTextarea(); // Limpa o textarea ao fechar
            }}
          >

          </Button>
          <Button
            variant='link'
            className='text-gray ms-auto'
            onClick={() => {
              close();
              resetTextarea(); // Limpa o textarea ao fechar
            }}
          >
            {props.cancel}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
// Interface para definir as props de CheckboxItem
interface CheckboxItemProps {
  data: {
    id_equipment: string;
    day_name: string;
    code_equipment: string;
    dayOfWeek: string;
    dayNameValue: string;
    equipmentPickupPercentage: number;
    selected_collection_percentage_physical: number;
  };
  onCheckboxChange: (idEquipment: string, dayName: string) => void;
  isChecked: boolean;
}

const user = storageService.getUser();

const formatToCurrency = (value) => {
  let decimalSeparator = user?.locale?.decimalSeparator;
  let thousandSeparator = user?.locale?.thousandSeparator;
  //let moneyPrefix = user.locale?.moneyPrefix;
  return HelperService.number_format_abbreviated(
    value,
    2,
    decimalSeparator,
    thousandSeparator
  );
};

// Componente memoizado para os checkboxes
const CheckboxItem: React.FC<CheckboxItemProps> = memo(
  ({ data, onCheckboxChange, isChecked }) => {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {/* Checkbox */}
        <input
          id={`cardId__${data.code_equipment}-${data.dayOfWeek}`}
          type="checkbox"
          checked={isChecked}
          onChange={() => onCheckboxChange(data.id_equipment, data.day_name)}
        />

        <strong style={{ width: "70px" }}>{data.code_equipment}</strong> -
        <span style={{ width: "45px" }}>{data.dayOfWeek}</span>
        <strong style={{ width: "70px", textAlign: "right" }}>
          {data.equipmentPickupPercentage}%
        </strong>
        <strong style={{ width: "60px", textAlign: "right" }}>
          {data.selected_collection_percentage_physical}%
        </strong>
      </div>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isChecked === nextProps.isChecked &&
      prevProps.data.id_equipment === nextProps.data.id_equipment &&
      prevProps.data.day_name === nextProps.data.day_name
    );
  }
);





export default ModalProgPickup;
